import React from 'react';
import '../../../styles/DashboardWidgets.css';
import './MacWorkflowsSidebar.css';
import ActiveWorkflowsWidget from './ActiveWorkflowsWidget';
import TriggerStatsWidget from './TriggerStatsWidget';
import WorkflowStatsWidget from './WorkflowStatsWidget';
import WorkflowsWidget from './WorkflowsWidget';
import RecipesWidget from './RecipesWidget';
// import AppsWidget from './AppsWidget';
import { useAnalytics } from '../../../hooks/useAnalytics';

const MacWorkflowsSidebarContent: React.FC = () => {
  const {
    activityStats,
    workflowSummary,
    workflowTypeStats,
    isLoading,
    error,
    notSubscribed,
    refetch
  } = useAnalytics();

  // Analytics are the user's own MAC data — hide them for non-MAC users
  // instead of showing a "Not subscribed" error in each card.
  return (
    <div className='dw-widgets'>
      {!notSubscribed && (
        <>
          <TriggerStatsWidget
            workflowTypeStats={workflowTypeStats}
            isLoading={isLoading}
            error={error}
            onRetry={refetch}
          />
          <WorkflowStatsWidget
            workflowTypeStats={workflowTypeStats}
            activityStats={activityStats}
            isLoading={isLoading}
            error={error}
            onRetry={refetch}
          />
        </>
      )}
      <WorkflowsWidget />
      <RecipesWidget />
      {/* <AppsWidget /> */}
      {!notSubscribed && (
        <ActiveWorkflowsWidget
          workflowSummary={workflowSummary}
          isLoading={isLoading}
          error={error}
          onRetry={refetch}
        />
      )}
    </div>
  );
};

export default MacWorkflowsSidebarContent;
